import DoubleCircle from '@/assets/icons/icon_expectation_001.svg';
import Circle from '@/assets/icons/icon_expectation_002.svg';
import Triangle from '@/assets/icons/icon_expectation_003.svg';
import { ForecastMark } from '@/lib/apollo/types/gen/graphql';

class ForecastMarkSelector {
  private forecastMark?: ForecastMark;

  constructor(forecastMark: ForecastMark | undefined) {
    this.forecastMark = forecastMark;
  }

  // 記号
  get markSymbol() {
    switch (this.forecastMark) {
      case ForecastMark.Excellent:
        return DoubleCircle;
      case ForecastMark.VeryGood:
        return Circle;
      case ForecastMark.Good:
        return Triangle;
      default:
        return '';
    }
  }
}

export const forecastMarkSelector = (forecastMark?: ForecastMark | null) => {
  return new ForecastMarkSelector(forecastMark || undefined);
};
